import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2GetLiabilityReportResponse,
  IIndirectTaxFilingV2LiabilityReportFiling,
  IIndirectTaxFilingV2LiabilityReportParams,
  IIndirectTaxFilingV2MutationResult,
} from './types';

const MAX_FILINGS_PER_REQUEST = 100;

function chunkIds(ids: readonly string[]): string[][] {
  const chunks: string[][] = [];
  for (let i = 0; i < ids.length; i += MAX_FILINGS_PER_REQUEST) {
    chunks.push(ids.slice(i, i + MAX_FILINGS_PER_REQUEST));
  }
  return chunks;
}

function buildQuery(
  corporationId: number,
  filingIds: readonly string[]
): string {
  const q = new URLSearchParams();
  q.append('corporationId', String(corporationId));
  filingIds.forEach((filingId) => q.append('filingIds', filingId));
  return q.toString();
}

export async function getIndirectTaxFilingV2LiabilityReport({
  params,
}: {
  params: IIndirectTaxFilingV2LiabilityReportParams;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2GetLiabilityReportResponse>
> {
  try {
    const filingIds = Array.from(new Set(params.filingIds));
    if (filingIds.length === 0) {
      return { success: true, data: { filings: [] } };
    }

    const batches = chunkIds(filingIds);
    const mergedFilings: IIndirectTaxFilingV2LiabilityReportFiling[] = [];

    for (const batch of batches) {
      const query = buildQuery(params.corporationId, batch);
      const response = await fetcher(
        `new-sales-tax/filings-v2/liability-report?${query}`,
        { method: 'GET' }
      );
      const json = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error:
            typeof json?.message === 'string'
              ? json.message
              : 'Failed to load liability report',
        };
      }

      const data = json as IIndirectTaxFilingV2GetLiabilityReportResponse;
      mergedFilings.push(...data.filings);
    }

    console.log({ mergedFilings });

    return { success: true, data: { filings: mergedFilings } };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to load liability report',
    };
  }
}
